/**
 * Shared Icon Components for Mode Configuration
 * These are React components that can be used in mode configs
 */

'use client';

export function TranscribeIcon({ className }: { className?: string }) {
  return (
    <svg 
      className={className} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="6" width="2.5" height="12" rx="1.25" fill="currentColor">
        <animate attributeName="height" values="12;16;12" dur="1s" repeatCount="indefinite" />
        <animate attributeName="y" values="6;4;6" dur="1s" repeatCount="indefinite" />
      </rect>
      <rect x="6" y="4" width="2.5" height="16" rx="1.25" fill="currentColor">
        <animate attributeName="height" values="16;20;16" dur="1.2s" repeatCount="indefinite" />
        <animate attributeName="y" values="4;2;4" dur="1.2s" repeatCount="indefinite" />
      </rect>
      <rect x="10" y="8" width="2.5" height="8" rx="1.25" fill="currentColor">
        <animate attributeName="height" values="8;12;8" dur="0.8s" repeatCount="indefinite" />
        <animate attributeName="y" values="8;6;8" dur="0.8s" repeatCount="indefinite" />
      </rect>
      <rect x="14" y="2" width="2.5" height="20" rx="1.25" fill="currentColor">
        <animate attributeName="height" values="20;24;20" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="y" values="2;0;2" dur="1.5s" repeatCount="indefinite" />
      </rect>
      <rect x="18" y="5" width="2.5" height="14" rx="1.25" fill="currentColor">
        <animate attributeName="height" values="14;18;14" dur="1.1s" repeatCount="indefinite" />
        <animate attributeName="y" values="5;3;5" dur="1.1s" repeatCount="indefinite" />
      </rect>
    </svg>
  );
}

